import { get } from "lodash";
import { DEPOSIT_AMELLIS_CIBLEMUT_SFTP } from "utils/api/graphql/mutations/subscription";
import Ciblemut from "./Ciblemut";

const depositAmellisCiblemut = async ({ client, variables }) => {
  const { data } = await client.mutate({
    mutation: DEPOSIT_AMELLIS_CIBLEMUT_SFTP,
    variables,
  });
  return JSON.parse(get(data, "depositAmellisCiblemutSftp") || "{}");
};

export const EXTERNAL_EXPORT = {
  AMELLIS: [
    {
      key: "CIBLEMUT",
      label: "LIST.HEADER.EXTERNAL_EXPORT.CIBLEMUT.LABEL",
      screen: Ciblemut,
      action: depositAmellisCiblemut,
    },
  ],
};
